module.exports = __webpack_public_path__ + "static/media/1.35a72415.png";